import { API, authClient } from "../index";

export const getMailboxThreads = (accessToken) => {
  return authClient(accessToken).get(`${API}/config/mailbox/threads`);
};

export const getMailboxMessage = (mailId, accessToken) => {
  return authClient(accessToken).get(`${API}/config/mailbox/messages/${mailId}`);
};

export const downloadMailboxAttachment = (mailId, attachmentIndex, accessToken) => {
  return authClient(accessToken).get(
    `${API}/config/mailbox/messages/${mailId}/attachments/${attachmentIndex}/download`,
    { responseType: "blob" }
  );
};

export const sendMailboxMail = (payload, accessToken) => {
  return authClient(accessToken).post(`${API}/config/mailbox/send`, payload);
};

export const searchMailboxThreads = (query, accessToken) => {
  const normalizedQuery = encodeURIComponent(query || "");
  return authClient(accessToken).get(
    `${API}/config/mailbox/threads/search?query=${normalizedQuery}`
  );
};

export const classifyMailboxMessage = (mailId, payload, accessToken) => {
  return authClient(accessToken).post(
    `${API}/config/mailbox/messages/${mailId}/classify`,
    payload
  );
};
